// extracted by mini-css-extract-plugin
export default {"block":"MapBlock_block__rVo7O","body-part":"MapBlock_body-part__TBNUN","map":"MapBlock_map__244dl","button-list":"MapBlock_button-list__Y-cSZ"};